import './Input.css';
import React, { forwardRef, useState } from 'react';
import { Input } from 'antd';
import 'antd/es/input/style/index.css';

type propTypes = {
  className?: string;
  style?: any;
  src?: string;
  alt?: string;
  type?:
    | 'text'
    | 'password'
    | 'date'
    | 'datetime-local'
    | 'file'
    | 'number'
    | 'search'
    | 'tel'
    | 'time';
  placeholder?: string;
  value?: string;
  autofocus?: boolean;
  disabled?: boolean;
  required?: boolean;
  onChange?: (value: string) => void;
  onEnterClick?: () => void;
  onFocusIn?: (e: React.SyntheticEvent<HTMLInputElement, Event>) => void;
  onFocusOut?: (e: React.SyntheticEvent<HTMLInputElement, Event>) => void;
};

/**
 * An input field with an image at the left side
 */
const InputWithImage = (
  {
    className = '',
    style = {},
    src = '',
    alt = '',
    type = 'text',
    placeholder = '',
    value,
    autofocus = true,
    disabled = false,
    required = false,
    onChange = () => {},
    onEnterClick = () => {},
    onFocusIn = () => {},
    onFocusOut = () => {},
  }: propTypes,
  ref
) => {
  const [focus, setFocus] = useState(false);

  const onKeyPress = (e) => {
    if (e.charCode === 13) {
      onEnterClick();
    }
  };

  return (
    <div
      className={
        `input-with-image-library pl-4 pr-2 ${focus ? 'focus' : ''} ` +
        className
      }
      style={{ ...style, width: '100%' }}
    >
      <span>
        <img src={src} alt={alt} />
      </span>
      <div style={{ width: '100%' }}>
        <Input
          ref={ref}
          disabled={disabled}
          type={type}
          placeholder={placeholder}
          value={value}
          autoFocus={autofocus}
          allowClear
          onChange={(e) => {
            onChange(e.target.value);
          }}
          onSelect={(e) => {
            setFocus(true);
            onFocusIn(e);
          }}
          onBlur={(e) => {
            setFocus(false);
            onFocusOut(e);
          }}
          onKeyPress={onKeyPress}
          required={required}
        />
      </div>
    </div>
  );
};

export default forwardRef(InputWithImage);
